import { Button, Group } from '@mantine/core';
import { IconLink, IconVideo } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { parseEventDescription } from 'src/Utils/eventLinks';

import styles from './EventSmartLinks.module.scss';
import { Props } from './EventSmartLinks.types';

const getLinkLabel = (url: string): string => {
  try {
    return new URL(url).hostname.replace(/^www\./, '');
  } catch {
    return url;
  }
};

const EventSmartLinks = ({ description }: Props) => {
  const { t } = useTranslation();

  const { videoLinks, otherLinks } = parseEventDescription(description);

  if (videoLinks.length === 0 && otherLinks.length === 0) {
    return null;
  }

  return (
    <Group gap="xs" className={styles.container}>
      {videoLinks.map(link => (
        <Button
          key={link}
          component="a"
          href={link}
          target="_blank"
          rel="noopener noreferrer"
          variant="filled"
          leftSection={<IconVideo size={16} />}
        >
          {t('event.details.joinVideoCall', 'Rejoindre la visio')}
        </Button>
      ))}
      {otherLinks.map(link => (
        <Button
          key={link}
          component="a"
          href={link}
          target="_blank"
          rel="noopener noreferrer"
          variant="light"
          leftSection={<IconLink size={16} />}
        >
          {getLinkLabel(link)}
        </Button>
      ))}
    </Group>
  );
};

export default EventSmartLinks;
